import { useQueryClient } from '@tanstack/react-query'
import { isEmpty } from 'lodash'
import { graphierQL } from 'utils'
import { useMap } from '~map-preview/states/map'
import {
  UpdateMapSettingsMutation,
  UpdateMapSettingsMutationVariables
} from '~map-settings/types/__generated/gql/graphql'
import { toast } from 'ui-components'
import { useRefetchMap } from '~map-preview/hooks/useRefetchMap'

const useUpdateMapName = () => {
  const map = useMap()
  const query = useQueryClient()
  const { refetch } = useRefetchMap()

  return async (name: string) => {
    const previousMap = query.getQueryData(['getMapById', map.id])

    query.setQueryData(['getMapById', map.id], (oldData) => {
      if (!oldData) return oldData
      return { ...oldData, name }
    })

    try {
      const input = {
        id: map.id,
        name: isEmpty(name) ? map.name : name
      }

      await updateMapName({ input })
      refetch()
    } catch (error) {
      // Rollback on failure
      query.setQueryData(['getMapById', map.id], previousMap)
      toast('Map name update failed')
    }
  }
}

const updateMapNameMutation = /* GraphQL */ `
  mutation UpdateMapName($input: UpdateMapSettingInput!) {
    updateMapSettings(input: $input) {
      id
      name
    }
  }
`

const updateMapName = async (variables) =>
  await graphierQL<
    UpdateMapSettingsMutation,
    UpdateMapSettingsMutationVariables
  >({
    useToken: true,
    query: updateMapNameMutation,
    variables
  })

export { useUpdateMapName }
